'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { ctw } from '@/common/utils/ctw';

const Tooltip = TooltipPrimitive.Root;

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipArrow = TooltipPrimitive.Arrow;

/** Renders the content in `document.body` — required when the trigger sits inside a
 *  `transform`ed ancestor (e.g. a virtualized list row), where the content's fixed
 *  positioning would otherwise resolve against that ancestor and get clipped by
 *  `overflow` on anything between it and the page. */
const TooltipPortal = TooltipPrimitive.Portal;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={ctw(
      // Light gray (`zinc-100`) to match the `?` affordance in QuestionMarkTooltip, replacing
      // the earlier light blue (`#EEF2F8`). The reasoning tooltip opts out with its own palette.
      'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md bg-zinc-100 px-3 py-1.5 text-xs text-[#0F1321] shadow-md',
      className,
    )}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger };
